Vivense.init['product'] = Vivense.init['product'] || [];

window.viveProductPage = window.viveProductPage || {};

Vivense.init['product'].push(function () {

    var formatter = new Intl.NumberFormat('tr-TR');

    var addToCartBtn = $(".add-to-cart-btn");
    var addToCartForm = $(".add-to-cart-form");
    var salePrice = $(".new-price");
    var basePrice = salePrice.data("value");
    var delPrice = $(".del-price");
    var discountedPrice = $(".discounted-price");
    var deliveryDate = $(".delivery-date");
    var bundleDiscount = $("#bundleDiscount");

    window.viveProductPage.addToCart = function (cartForm) {

        $.ajaxSetup({cache: false});

        var datas = cartForm.serialize();

        $.post('/index.php?option=com_virtuemart&nosef=1&view=cart&task=addJS&format=json', datas).done(
            function (result, textStatus) {
                var datas = JSON.parse(result);
                if (datas.stat == 1) {

                    window.viveProductPage.addToCartClickEvent();

                    window.setTimeout( function (){
                        window.location='/siparis-listesi.html';
                    },1000);


                } else if (datas.stat == 2) {

                    var value = cartForm.find('.quantity-input').val();
                    var txt = cartForm.find(".pname").val();

                    $.jAlert({
                        'id': "error-alert-box",
                        'title': '&nbsp;',
                        'content': '<span class="product-alert-text">' + datas.msg + '</span>',
                        'theme': 'default',
                        'size': 'sm',
                        'showAnimation': 'fadeIn',
                        'hideAnimation': 'fadeOut',
                        'btns': [{'text': 'KAPAT', 'id': 'cancel-id'}]
                    });


                } else {
                    $.jAlert({
                        'id': "error-alert-box",
                        'title': '&nbsp;',
                        'content': '<span class="product-alert-text">' + datas.msg + '</span>',
                        'theme': 'default',
                        'size': 'sm',
                        'showAnimation': 'fadeIn',
                        'hideAnimation': 'fadeOut',
                        'btns': [{'text': 'KAPAT', 'id': 'cancel-id'}]
                    });
                }

                addToCartBtn.html('SEPETE EKLE');
            });

        $.ajaxSetup({cache: true});

    };

    window.viveProductPage.addToCartClickEvent = function () {

        var selectedVariant = '';

        if ($(".active-size-box").length) {
            var chosenVariantElement = $(".active-size-box").parent();
            selectedVariant = chosenVariantElement.data('variantvalue');
        }


        dataLayer.push({
            'Category': 'Enhanced Ecommerce',
            'Action': 'Browse',
            'Label': 'Add to Cart',
            'Value': 0,
            'noninteraction': false,
            'ecommerce': {
                'currencyCode': 'TRY',
                'add': {
                    'actionField': {
                        'list': window.product.lastViewedCategory + ' Listing' // Product List Type
                    },
                    'products': [{
                        'name': window.product.name,
                        'id': window.product.sku,
                        'price': salePrice.data('value'),
                        'brand': 'Vivense',
                        'category': window.product.categoryName,
                        'list': window.product.lastViewedCategory + ' Listing',
                        'variant': selectedVariant,
                        'quantity': 1,
                        'dimension11':window.product.discountRate.toString(),
                        'dimension12':window.product.isOnShowroom ? 'Yes' : 'No',
                        'dimension13':window.product.imageCount.toString()
                    }]
                }
            },
            'event': 'eeEvent'
        });
        
        /* Personaclick: Adding a product to the cart */
        personaclick("track", "cart", {
            id: window.product.sku,
            amount: 1
        });
    };

    window.viveProductPage.setPopOverContent = function (sum) {
        var popOverContent = $(".popover-content");
        var assemblyInfo = $('#assembly-info');
        var componentPriceTable = $('.product-price-details');
        var orangeText = componentPriceTable.find('.orange-text');

        var freeAssemblyLimit = assemblyInfo.data('limit');
        var isFreeAssemblyCategory = assemblyInfo.data('is-free-assembly-cat');

        if (sum < freeAssemblyLimit && !isFreeAssemblyCategory) {

            popOverContent.children().text(freeAssemblyLimit +" TL altı ürünlerin kurulumu müşteriye aittir veya ücretli olarak Vivense tarafından sağlanabilir.");
            popOverContent.css("width", "170px");
            popOverContent.children().css("width", "156px");
            /*var newTopOffset = orangeText.offset().top - ($(".popover-content").outerHeight() / 2) + (orangeText.outerHeight() / 2);
            $(".popover-product-details").offset({top: newTopOffset});*/
            $("#free-assembly").hide();

        }
        else {

            popOverContent.children().text("Bu takımın içeriğini değiştirebilirsin.");
            popOverContent.css("width", "");
            /*var newTopOffset = orangeText.offset().top - (popOverContent.outerHeight() / 2) + (orangeText.outerHeight() / 2);
            $(".popover-product-details").offset({top: newTopOffset});*/
            $("#free-assembly").show();

        }

    };


    window.viveProductPage.calculateComponentPrice = function () {
        var quantityCounter = $(".component_quantity_counter");
        var sum = 0;

        quantityCounter.each(function () {

            var inputBox = $(this);

            var componentAdded = $("#form_product_component" + inputBox.data('component') + "_checked");

            var componentCartPrice = $(".component-price-" + inputBox.data('component'));
            componentCartPrice.attr('data-pieces', inputBox.val());

            if (componentAdded.val() == 1) {
                var componentSumTd = $(".component-edit-sumPrice-" + inputBox.data('component'));

                componentSumTd.html((inputBox.val() * componentSumTd.data('piece-price')).toLocaleString('tr-TR') + " TL");

                componentCartPrice.html(inputBox.val() + " x " + componentSumTd.data('piece-price').toLocaleString('tr-TR') + " TL");


                $("#form_product_component" + inputBox.data('component') + "_count").val(inputBox.val());

                sum += inputBox.val() * componentSumTd.data('piece-price');


                $( ".rowWrapper" ).each(function( index ) {
                    if($( this ).attr("data-fabric-component") == inputBox.data('component') && $( this ).attr("data-fabric-component-key") > inputBox.val()){
                            $( this ).remove();
                            $('.fabricPopupWrapper__popupInner__header_variants__productCard[data-top-module-id="'+ inputBox.data('component') +'-'+ $( this ).attr("data-fabric-component-key") +'"]').remove();
                            fabricSessionRemove(inputBox.data('component')+'-'+ $( this ).attr("data-fabric-component-key"));
                    }
                });

                for(var i = 1; i <= Number(inputBox.val()); i++){
                    if($('.rowWrapper[data-fabric-component-id="'+ inputBox.data('component') +'-'+i+'"]').length){
                        continue;
                    }
                    var clone = $('.defaultRowWrapper[data-fabric-component-id="'+ inputBox.data('component') +'"]').clone(true);
                    clone.attr("class", "rowWrapper");
                    clone.attr("style", "");
                    clone.attr("data-fabric-component-id", inputBox.data('component') +'-'+i);
                    clone.attr("data-fabric-component-key", i);
                    clone.children(".fabric-productName").children("span").text(i+'.');
                    clone.children(".fabricItemWrapper").each(function () {
                        var module = $(this).attr("data-module");
                        $(this).children(".defaultFabric").attr("data-default-module-id", module+'-'+i);
                        $(this).children(".changedFabric").attr("data-module-id", module+'-'+i);
                        $(this).children(".changedFabric").attr("data-default-module-id", module+'-'+i);
                        $(this).children(".changedFabric").children(".fabricDeleteBtn").attr("data-choose-module-id", module+'-'+i);
                        $(this).children(".changedFabric").children(".fabricDeleteBtn").attr("data-choose-module-id", module+'-'+i);
                        $(this).children(".fabricAction").attr("data-choose-module-id", module+'-'+i);

                        if($('.fabricPopupWrapper__popupInner__header_variants__productCard[data-module-id="'+ module +'-'+i+'"]').length == 0){
                            var headerClone = $('.defaultFabricPopupWrapper__popupInner__header_variants__productCard[data-module-id="'+ module +'"]').clone(true);
                            headerClone.attr("class", "fabricPopupWrapper__popupInner__header_variants__productCard header__selected");
                            headerClone.attr("style", "");
                            headerClone.attr("data-top-module-id", headerClone.attr("data-top-module-id")+'-'+i);
                            headerClone.attr("data-module-id", headerClone.attr("data-module-id")+'-'+i);
                            headerClone.children(".fabricPopupWrapper__popupInner__header_variants__productCard__title").children("span").text(i+'.');
                            headerClone.children(".fabricPopupWrapper__popupInner__header_variants__productCard__fabric").attr("class", "fabricPopupWrapper__popupInner__header_variants__productCard__fabric selected--module");
                            headerClone.children(".fabricPopupWrapper__popupInner__header_variants__productCard__fabric").attr("data-module-id", headerClone.attr("data-module-id"));
                            headerClone.children(".fabricPopupWrapper__popupInner__header_variants__productCard__fabric").attr("data-top-module-id", headerClone.attr("data-top-module-id"));
                            setPrice(module +'-'+i, 0);
                            $('#mCSB_3_container').append(headerClone);

                        }
                    });

                    if(i == 1){
                        $('.defaultRowWrapper[data-fabric-component-id="'+ inputBox.data('component') +'"]').after(clone);
                    }else{
                        $('.rowWrapper[data-fabric-component-id="'+ inputBox.data('component') +'-'+(i-1)+'"]').after(clone);
                    }
                    fabricSessionAdd(false);

                }
            }

        });

        window.viveProductPage.setPopOverContent(sum);

        var fabricPrice = $(".component-price-fabric").attr('data-cart-fabric-price');
        fabricPrice = parseInt(fabricPrice);
        if(fabricPrice > 0){
            sum = sum + fabricPrice;
        }

        var discount = getBundleDiscount(sum);
        discount = parseInt(discount);
        if(discount < 0){
            sum = sum + discount;
        }

        $(".component-sumPrice").html(formatter.format(parseInt(sum)) + " TL");

        salePrice.html(formatter.format(parseInt(sum)) + " TL");
        salePrice.data('value', parseInt(sum));

        delPrice.html(formatter.format(parseInt(sum * delPrice.data('value') / basePrice)) + " TL");

        discountedPrice.html(formatter.format(parseInt(sum * discountedPrice.data('value') / basePrice)) + " TL");

        $("#form_components_sales_price").val(sum);
    };


    $(".variant-div").click(function () {

        var chosendiv = $(this);
        var chosen = chosendiv.parent();
        var span = $(".variant-span");
        var deliveryBottomInfo = $("span.delivery-info");

        span.html("Seçiminiz: " + chosen.data('variantvalue'));
        salePrice.html(formatter.format(parseInt(chosen.data('price'))) + " TL");
        salePrice.data('value', parseInt(chosen.data('price')));

        delPrice.html(formatter.format(parseInt(chosen.data('price') * delPrice.data('value') / basePrice)) + " TL");
        discountedPrice.html(formatter.format(parseInt(chosen.data('price') * discountedPrice.data('value') / basePrice)) + " TL");

        $("#customPrice0127").val(chosen.data('customfield'));

        if (chosen.data('deliverydate') != '') {
            deliveryDate.html(chosen.data('deliverydate'));
            deliveryBottomInfo.html(chosen.data('deliverydate'));
        }
        if (chosen.data('images') != '') {
            $("#media_" + chosen.data('images')).click();

        }

    });

    $(".video_icon").click(function () {

        var id = $(this).attr("href").slice(1);

        $("." + id).click();

    });

    addToCartBtn.click(function () {

        addToCartBtn.html('<i class="fa fa-spinner fa-spin" style="font-size:24px"></i>');

        window.viveProductPage.addToCart(addToCartForm);

    });

    function changeQuantityInput(input, direction){
        const inputValue = parseInt(input.val());
        const newValue = inputValue + direction;
        const maxValue = parseInt(input.data('maxvalue'));

        if(newValue < 0 || newValue > maxValue){

            return;

        }

        input.val(newValue).change();
    }

    function getBundleDiscount(sum) {

        var selectedProduct;
        var defaultProductQuantities=[];
        var componentId =0;
        var defaultProductQuantity = 0;
        var discount = bundleDiscount.data('discount');

        $('td[class^="component-edit-sumPrice"]').each(function () {
            if($(this).data('default-qty') > 0 ) {
                componentId = $(this).data('component-id');
                selectedProduct =$(".component-price-"+componentId);

                if(selectedProduct && selectedProduct.attr('data-pieces')>0){

                    defaultProductQuantities.push( parseInt(selectedProduct.attr('data-pieces')/$(this).data('default-qty')));
                }else{
                    defaultProductQuantities.push(0);
                    return false;
                }
            }
        });

        defaultProductQuantity = Math.min.apply(Math,defaultProductQuantities);
        var newDiscount = discount*defaultProductQuantity;

        bundleDiscount.html(formatter.format(parseInt(newDiscount)) + " TL");

        return newDiscount;
    }


    $('[data-button="decrease"]').on('click', function () {
        const $this = $(this);
        const input = $this.closest('[data-counter]').find('.component_quantity_counter');
        changeQuantityInput(input, -1);

    });

    $('[data-button="increase"]').on('click', function () {
        const $this = $(this);
        const input = $this.closest('[data-counter]').find('.component_quantity_counter');
        changeQuantityInput(input, 1);
    });

    $(".component_quantity_counter").change(function (e) {
        const $this = $(this);
        const value = parseInt($this.val());
        if(value === 0){
            removeComponent.bind($this)();
            return;
        }

        window.viveProductPage.calculateComponentPrice();

    });

    $('body').on('click', ".component-add-button", function () {

        var added = $(this);

        $("#form_product_component" + added.data("component") + "_checked").val(1);

        window.viveProductPage.calculateComponentPrice();

        added.css("display", "none");

        $("#product_count_component-" + added.data("component")).css("display", "");

        $(this).closest('[data-counter]').find('.quantity-component').show();


        $(".component-" + added.data("component")).css("display", "");

        $('.rowWrapper[data-fabric-component-id="'+ added.data("component") +'-1'+'"]').css("display", "");
        $('.fabricPopupWrapper__popupInner__header_variants__productCard[data-top-module-id="'+ added.data("component") +'-1'+'"]').css("display", "");
        $('.fabricPopupWrapper__popupInner__header_variants__productCard[data-top-module-id="'+ added.data("component") +'-1'+'"]').addClass("header__selected");
        $('.fabricPopupWrapper__popupInner__header_variants__productCard__fabric[data-top-module-id="'+ added.data("component") +'-1'+'"]').addClass("selected--module");
        fabricSessionAdd(false);
        setValueHiddenProductComponentFabric();
        $(".minus-" + added.data("component")).css("display", "");



    });


    function removeComponent(){

        var componentQuantity = $(".component_quantity_counter");

        var addedComponentCount = 0;

        componentQuantity.each(function () {

            var inputBox = $(this);

            var componentAdded = $("#form_product_component" + inputBox.data('component') + "_checked");

            if (componentAdded.val() == 1) {
                addedComponentCount++;
            }


        });

        var deleted = $(this);

        if (addedComponentCount > 1) {


            deleted.closest('.quantity-component').css("display", "none");

            $("#form_product_component" + deleted.data("component") + "_checked").val(0);
            $("#form_product_component" + deleted.data('component') + "_count").val(0);

            var componentEditPrice = $(".component-edit-sumPrice-" + deleted.data("component"));
            componentEditPrice.html('<hr class="none-component">');

            $(".component_quantity_counter" + deleted.data("component")).css("display", "none");

            $(".add-button-" + deleted.data("component")).css("display", "");

            $(".component-" + deleted.data("component")).css("display", "none");

            $('.rowWrapper[data-fabric-component="'+ deleted.data("component") +'"]').remove();
            $('.fabricPopupWrapper__popupInner__header_variants__productCard[data-top-module="'+ deleted.data("component") +'"]').remove();
            fabricSessionRemove(null,deleted.data("component"));


            window.viveProductPage.calculateComponentPrice();

        }else{
            deleted.val(1).change();
        }
    }


    $(".ask-question-button").click(function (e) {

        e.preventDefault();

        var name = $("#ask-question-name");
        var product = $(".product-name");
        var productName = product.data("pname");
        var productsku = product.data("sku");
        var email = $("#ask-question-email");
        var question = $("#question-text");

        var modalHtml = "<p><strong>Ad Soyad:</strong> " + name.val() + "</p>";
        modalHtml += "<p><strong>E-Posta Adresi:</strong> " + email.val() + "</p>";
        modalHtml += "<p><strong>Ürün:</strong> " + productName + "</p>";
        modalHtml += "<p><strong>Soru:</strong> " + question.val() + "</p>";

        $(".question-sended-modal-ended").html(modalHtml);

        $.ajax('/ajax/mail/ask_question.php', {
            method: 'POST',
            data: 'task=sendMail&email=' + email.val() + "&pname=" + productName + "&sku=" + productsku + "&name=" + name.val() + "&question=" + question.val()
        })
            .done(function (data, textStatus, jqXHR) {
                console.log(data);
                response = JSON.parse(data);

                $(".ask-question-modal").modal('hide');


                $(".question-sended-modal").modal();

            })
            .fail();

    });

    $(".open-ask-question-modal").click(function (e) {

        $.ajax('/ajax/mail/ask_question.php', {
            method: 'POST',
            data: 'task=getUser'
        })
            .done(function (data, textStatus, jqXHR) {

                response = JSON.parse(data);

                $("#ask-question-email").val(response.email);
            })
            .fail();

        $(".ask-question-modal").modal();


    });

    $("#city_selection").change(function (e) {

        $.ajax('/ajax/product/get_delivery_detail.php', {
            method: 'POST',
            data: 'city=' + $(this).val()
        })
            .done(function (data, textStatus, jqXHR) {

                response = JSON.parse(data);

                if (response === 1) {
                    $("#delivery-information-1").show();
                    $("#delivery-information-2").hide();
                }
                else if (response === 2) {
                    $("#delivery-information-1").hide();
                    $("#delivery-information-2").show();
                } else {
                    $("#delivery-information-1").hide();
                    $("#delivery-information-2").hide();
                }

            })
            .fail();

    });


    window.viveProductPage.limitedAvailability = function(){

        var limitedAvailabilityArea = $(".limited-availability-area");

        if(limitedAvailabilityArea.length > 0){

            $.get("/ajax/product/get_stock_quantity.php?p_id="+$(".prodid").val(), function(result){
                if(result.success && result.quantity > 0){
                    limitedAvailabilityArea.find(".limited-availability-quantity").html(result.quantity);
                    limitedAvailabilityArea.show("slow");
                }
            });

        }
    };

    $(document).ready(function () {

        $("#lastViewedCategory").val(window.product.lastViewedCategory);
        $("#lastBreadCrumb").val(window.product.lastBreadCrumb);

        $.ajax('/ajax/product/get_campaign.php', {
            method: 'GET',
            dataType: 'json',
            data: 'p_id=' + $(".prodid").val()+"&price="+ salePrice.data('value')
        })
            .done(function (data, textStatus, jqXHR) {

                if (data.showCampaignPanel && data.content != '') {
                    $('#panel-campaign').show();
                    $('.campaign-list-link').show();
                }

                $('#panel-campaign').find('.panel-body').html(data.content);
                $('.login-link').click(function () {
                    Vivense.loginPopup.open("campaign");
                });
            })
            .fail();
        if(window.isAdmin){
            $.ajax('/ajax/product/getAdminInfos.php', {
                method: 'GET',
                data: 'productId=' + $(".prodid").val()
            })
                .done(function (data, textStatus, jqXHR) {
                    $(".testfiyat").html(data);
                })
                .fail();
        }

    });


    $(".open-nearest-showroom").click(function (e) {

        $(".nearest-showroom").modal();
        hj('trigger', 'nearest-showroom');

    });

    var campaignDate = $(".campaign-date").data("date");
    $(".campaign-date")
        .countdown(campaignDate, function (event) {
            $(this).html(
                event.strftime(' ' + '<i></i>'
                    + 'İndirim için son '
                    + '<strong>'
                    + '%H:%M:%S'
                    + '</strong>')
            );
        });

    $(document).ajaxComplete(function () {
        var fullW = $("#panel-campaign .panel-body .row").find(".fullWidth");
        if (fullW.hasClass("campaing-only-bg-img") || fullW.hasClass("text-only-bg-img")) {
            $("#panel-campaign .panel-body").addClass("no-padding");
        }
    });


    $(".custom-panel .panel-heading").on("click", function () {
        $(this).toggleClass("open");
        $(this).next(".panel-body").stop().slideToggle();
    });

    $('.delivery-information').on('click', function () {
        $(".pd-delivery-information").addClass("open");
        $('#delivery-information .panel-body').show();
    });


    $("#payment-method-link").on("click", function () {

        $("#payment-method").find(".panel-heading").addClass("open");
        $("#payment-method").find(".panel-body").slideDown();
    });

    $("#return-information-link").on("click", function () {

        $("#return-information").find(".panel-heading").addClass("open");
        $("#return-information").find(".panel-body").slideDown();
    });
    $("#guarantee-information-link").on("click", function () {

        $("#guarantee-information").find(".panel-heading").addClass("open");
        $("#guarantee-information").find(".panel-body").slideDown();
    });

    $(".delivery-info").click(function (e) {
        e.preventDefault();

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'Category': 'Product Detail Page', 
            'Action': 'Teslimat & Kurulum',
            'Label': window.product.name,
            'noninteraction': true,
            'event': 'gaEvent'
        });

        $('html,body').animate({scrollTop: $("#delivery-information").offset().top - 100});

        $("#delivery-information").find(".panel-heading").addClass("open");
        $("#delivery-information").find(".panel-body").slideDown();
    });

    $(".view-in-showroom").click(function(e) {
        e.preventDefault();

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'Category': 'Product Detail Page', 
            'Action': 'Showroom',
            'Label': window.product.name,
            'noninteraction': true,
            'event': 'gaEvent'
        });

        var showroom_location = $(this).attr("href");

        $('html,body').animate({scrollTop: $(showroom_location).offset().top - 100});

        $("#vivense-showroom-tab").find(".panel-heading").addClass("open");
        $("#vivense-showroom-tab").find(".panel-body").slideDown();
    });
    


    $(".components-change a").on("click", function () {

        $("#component").find(".panel-heading").addClass("open");
        $("#component").find(".panel-body").slideDown();

    });

    if ((window.userId > 0) && window.isAdmin) {
        $(".feedback_product").show();
        $("#feedback_product").show();
        $(".admin-rate-product").show();
    }

    $(".feedback_send").on("click", function () {

        $.ajax({
            method: "POST",
            url: "/ajax/product/feedback_product.php",
            data: {sku: $(this).data("sku"), link: $(this).data("link"), productID: $(this).data("product-id"), sender: window.userEmail, feedback:$(this).closest("form").find("textarea").val()}
        }).done(function (success) {
            $("#feedback_product_popup").find(".close").trigger("click");
            swal({
                title: "Başarılı",
                text: "Bildirim başarılı bir şekilde iletildi, teşekkürler.",
                type: "success",
                confirmButtonText: 'Tamam'
            })
        }).fail(function (error) {
            $("#feedback_product_popup").find(".close").trigger("click");
            swal({
                title: "Hata",
                text: "İşlem gerçekleştirilemedi, lütfen tekrar deneyin.",
                type: "error",
                confirmButtonText: 'Tamam'
            })
        });
    });


    window.viveProductPage.limitedAvailability();


    if(document.querySelector('.pdp-promotion-text')){
        if (document.querySelector('.glv_lowest_price')) {
            document.querySelector('.pdp-promotion-text').style.display = 'none';
        } else {
            document.querySelector('.pdp-promotion-text').style.display = 'flex';
        }
    }



});